import { createContext } from 'react';
import { Session, UserContext } from './types';

interface HeaderContextInterface {
  isEUDC: boolean;
  lang: string;
  session?: Session;
  user?: UserContext;
  pageURL?: string;
  pageURLPath?: string;
}

const defaultHeaderCtx = {
  isEUDC: false,
  lang: 'en',
  session: undefined,
  user: undefined,
  pageURL: undefined,
  pageURLPath: undefined,
};

const HeaderContext = createContext<HeaderContextInterface>(defaultHeaderCtx);

export default HeaderContext;
